let a = {
  title: "",
  titleEn: "",
  subtitle: "",
  subtitleEn: "",
  dec: "",
  decEn: "",
  img: "",
  imgMobile: "",
  list: [],
};
let b = {
  title: "",
  titleEn: "",
  dec: "",
  decEn: "",
};
export default {
  num: '03',
  title: "守护生态环境",
  titleEn: "Protecting the Ecological Environment",
  btn: [
    {
      title: "清洁运营，绿色发展",
      titleEn: "Clean Operation, Green Development",
      subtitle: "",
      subtitleEn: "",
      dec:"<p>" +
          "在环保治理实践中，公司明确长期环境目标，提出“环境零影响工厂”愿景，旨在从源头减少排放、降低对周边社区的影响，实现绿色生产。"
      +"</p>"+
      "<p>" +
          "2024年，公司在环境管理方面未发生环保行政处罚或重大环境事故，展现出体系化管理的成效。在关键环保指标上，公司推进 VOC 排放、废弃物处理、水耗三大领域的系统优化："
          +"</p>"
          +"<ul>"
      + "<li>" + "VOC 排放：2030 年目标为单车 0.38 千克/车，2024 年实际已控制在 0.41 千克/车；" + "</li>"
      + "<li>" + "废弃物处理：2030 年目标为单车 2.00 千克/车，2024 年实际为 4.88 千克/车；" + "</li>"
      + "<li>" + "水耗管理：2030 年目标为单车 4.00 立方米/车，2024 年实际为 4.85 立方米/车。" + "</li>"
      + "</ul>"
      +"<p>" +
          "公司所有工厂均已通过 ISO14001 环境管理体系认证，体现其在环境治理方面的规范性与国际化水平。"
          +"</p>"
      ,
      decEn:"<p>" +
          "In practice, SAIC VOLKSWAGEN has set long-term environmental goals and formulated the vision of building “zero-impact factories,” aiming to reduce emissions at the source, minimize impacts on surrounding communities, and achieve green manufacturing."
          +"</p>"+
          "<p>" +
          "In 2024, the Company recorded no environmental administrative penalties or major environmental incidents, demonstrating the effectiveness of its systematic management approach. Across key environmental indicators, SAIC VOLKSWAGEN advanced systematic optimization in VOC emissions, waste treatment, and water consumption:"
          +"</p>"
          +"<ul>"
          + "<li>" + "VOC emissions: Target of 0.38 kg/vehicle by 2030; actual performance in 2024 was 0.41 kg/vehicle." + "</li>"
          + "<li>" + "Waste treatment: Target of 2.00 kg/vehicle by 2030; actual performance in 2024 was 4.88 kg/vehicle." + "</li>"
          + "<li>" + "Water consumption: Target of 4.00 m³/vehicle by 2030; actual performance in 2024 was 4.85 m³/vehicle." + "</li>"
          + "</ul>"
          +"<p>" +
          "All SAIC VOLKSWAGEN plants have obtained ISO 14001 environmental management system certification, reflecting the Company’s standardized and internationally aligned environmental governance practices."
          +"<p>"
      ,
      img: 'https://www.csvw.com/u/cms/www/202512/291543525HRL.jpg',
      list: [
        {
          title: "废弃物管理",
          titleEn: "Waste Management",
          dec:"<p>" +
              "上汽大众严格遵守国家关于固体废物污染防治的法律法规，通过制度化的管理体系全面推进废弃物全过程减量化、无害化和资源化。公司制定《废弃物管理程序》等文件，明确危险废弃物的分类、存储、转运和处置要求，并通过标准化管理确保全过程可控。围绕源头减量，公司在产品设计阶段同步实施环保措施，从原材料使用到工艺优化持续减少废弃物产生。"
              +"</p>"+
              "<p>" +
              "公司进一步将废物管理与绿色制造深度融合，并在嘉定区建成上汽大众全国首个“无废工厂”。安亭基地已经100%使用绿电（水电），2024年度减少约13.1万吨二氧化碳排放。同时，公司推动新能源车动力电池回收与梯次利用，构建电池材料循环体系，提升资源利用效率。"
              +"</p>"
          ,
          decEn:"<p>" +
              "SAIC VOLKSWAGEN strictly complies with national regulations on solid waste pollution control and promotes a comprehensive approach to waste reduction, harmless treatment, and resource reuse. Through institutional frameworks such as the Waste Management Procedure, the Company clearly defines the requirements for the classification, storage, transfer, and disposal of hazardous waste, ensuring full-process traceability and compliance. With a focus on source reduction, environmental considerations are incorporated into product design and manufacturing, leading to significant decreases in waste generation. "
              +"</p>"+
              "<p>" +
              "To further integrate waste management with green manufacturing, SAIC VOLKSWAGEN established its first “Zero-Waste Factory” at the Jiading District. The Anting plant achieved 100% green electricity(hydropower) usage and reduced approximately 131,000 tons of CO₂ emissions in 2024. Additionally, the Company advances the recycling and second-life utilization of NEV power batteries, forming a circular system for critical battery materials."
              +"</p>"
          ,
        },
        {
          title: "水资源及废水管理",
          titleEn: "Water Resources and Wastewater Management",
          dec:"<p>" +
              "上汽大众严格遵循《中华人民共和国水法》《中华人民共和国水污染防治法》等法律法规，构建覆盖取水、用水、排水全流程的水资源管理体系，通过提升设备管理、优化工艺流程以及推广节水创新技术，持续提高水资源利用效率，最大限度减少对环境的影响。"
              +"</p>"
              + "<ul>"
              +"<li>在源头管控方面，公司通过定期检查水阀、管道及设备运行情况，及时发现并处理漏损，确保基础设施高效运行。</li>"
              +"<li>生产过程中，公司将冷凝水回收再利用；厂区雨污分流系统与中水回用设施的运行进一步提升循环用水比例；油漆车间采用水性化回收系统减少新水使用。</li>"
              +"<li>在废水处理方面，公司严格依据排放标准执行处理流程，并通过站内预处理和循环利用机制减少达标排放量。</li>"
              +"<li>通过制度化管理、技术革新及循环利用措施，上汽大众持续提升水资源管理水平，在保障生产需求的同时，致力于实现绿色用水与环境友好型运营。</li>"
          ,
          decEn:"<p>" +
              "SAIC VOLKSWAGEN follows Water Law of the People’s Republic of China and Water Pollution Prevention and Control Law of the People’s Republic of China to implement a comprehensive water-resource management system covering water intake, usage, and discharge. By strengthening equipment management, optimizing production processes, and adopting innovative water-saving technologies, the Company continuously improves water efficiency while minimizing environmental impact. "
              +"</p>"
              + "<ul>"
              +"<li>In source management, regular inspections of valves, pipelines, and equipment help promptly identify and fix leakages.</li>"
              +"<li>During production, condensed water generated from processes is recycled. Rainwater diversion systems and reclaimed-water facilities further increase the share of recycled water. Water-based paint recovery systems in coating workshops reduce the need for fresh water.</li>"
              +"<li>SAIC VOLKSWAGEN also strictly adheres to wastewater treatment standards, combining on-site pretreatment and recycling to reduce discharge volumes. </li>"
              +"<li>Through institutional governance, technological innovation, and circular water-use strategies, SAIC VOLKSWAGEN steadily enhances water-resource management performance, achieving greener water consumption while ensuring stable production operations.</li>"
          ,
        },
        {
          title: "废气管理",
          titleEn: "Waste Gas Management",
          dec:"<p>" +
              "上汽大众严格遵循《中华人民共和国大气污染防治法》等法律法规及地方排放标准，通过第三方空气检测确保结果符合国家与地方要求，并持续推进源头减量、工艺优化和设备升级，以最大限度降低生产过程中的VOCs（挥发性有机物）排放。公司坚持“源头治理优先”的原则，从原材料选择、生产工艺到末端治理均进行系统优化。"
             + "</p>" +
              "<p>" +
              "在源头材料方面，公司采用国产高固含量水性涂料替代传统溶剂型材料，通过优化固化剂配方，使其能够实现无铅化并减少约48%的VOC排放，该类材料已在工厂全面推广。在工艺优化层面，公司创新实施两涂一烘工艺，减少烘干过程中的能耗与溶剂挥发量，部分工艺单车VOC排放减少71%；此外，采用2010V水性涂装工艺并配套前处理优化措施，使VOC排放降低达95%。"
              + "</p>" +
              "<p>" +
              "设备升级方面，公司引入先进的RTO焚烧净化技术处理废气，提高废气中有机物的去除率，使处理后尾气中的VOCs进一步减少；在部分车间新增VOC过滤系统，使整体排放降低达33%。这些措施共同构成了上汽大众降低VOC排放的系统化路径，显著提升了工厂的绿色生产水平。"
              + "</p>"
          ,
          decEn:'<p>' +
              'SAIC VOLKSWAGEN strictly adheres to Air Pollution Prevention and Control Law of the People’s Republic of China and regional emission standards, conducting third-party air testing to ensure compliance. The Company actively reduces VOC emissions through source reduction, process optimization, and end-of-pipe treatment, following the principle of “prevention at the source and continuous optimization.'
              + "</p>" +
              "<p>" +
              "At the material level, SAIC VOLKSWAGEN uses high–solid content, water-borne coatings to replace traditional solvent-based materials. By optimizing curing agents and eliminating lead components, the Company reduces VOC emissions by approximately 48%. These environmentally friendly materials have been widely adopted across multiple plants."
              + "</p>" +
              "<p>" +
              "For process improvement, the Company implemented an innovative “two-coat one-bake” system, which reduces both energy consumption and solvent evaporation. In some workshops, this optimization has led to a 71% reduction in VOC emissions per vehicle. Furthermore, by adopting the 2010V water-based coating process combined with optimized pre-treatment, VOC emissions have decreased by up to 95%."
              + "</p>" +
              "Regarding equipment upgrades, SAIC VOLKSWAGEN utilizes advanced RTO (Regenerative Thermal Oxidizer) technology to significantly improve waste-gas purification efficiency. Newly installed VOC filtration systems in several workshops further reduce emissions, collectively lowering VOC concentrations by around 33%. These measures collectively form SAIC VOLKSWAGEN's systematic approach to reducing VOC emissions, significantly enhancing the plant's green production standards."
              + "</p>"
          ,
        }
      ],
    },
    {
      title: "生物共生，自然共荣",
      titleEn: "Live Together, Nature Co-prosperity",
      subtitle: "",
      subtitleEn: "",
      dec:"公司深知建造工厂和生产运营过程导致的土地用途更改、空气污染、光害及水污染、温室气体排放均可能造成生物多样性损失。因此，上汽大众积极投身于生物多样性保护，以实际行动守护地球生态平衡。公司严格遵守《汽车整车制造项目环境影响评价文件审批原则》《上海市人民政府关于发布上海市生态保护红线的通知》《省政府关于印发江苏省国家级生态保护红线规划的通知》等国家及地区相关的法律法规及政策性文件，已识别公司的整体环境风险，并形成《组织内外部因素分析清单》和《相关方的需求和期望分析清单》，覆盖公司的生产运行情况、政府、股东、周边居民等相关方的需求和期望等会给公司带来的环境风险。",
      decEn:"The Company is well aware that land-use changes, air pollution, light pollution, water pollution, and greenhouse gas emissions arising from plant construction and production operations may all lead to biodiversity loss. Therefore, SAIC VOLKSWAGEN actively engages in biodiversity conservation and takes concrete actions to safeguard the ecological balance of the planet. The Company strictly complies with national and regional laws, regulations, and policy documents such as the Approval Principles for Environmental Impact Assessment Documents of Automobile Manufacturing Projects, the Notice of the Shanghai Municipal People’s Government on the Release of the Shanghai Ecological Protection Red Line, and the Provincial Government’s Notice on the Issuance of the Jiangsu Province National Ecological Protection Red Line Plan. It has identified its overall environmental risks and developed an Internal and External Factors Analysis Checklist and a Stakeholder Needs and Expectations Analysis Checklist. These cover environmental risks arising from the Company’s production and operation activities as well as the needs and expectations of stakeholders including the government, shareholders, and surrounding residents.",
      img: 'https://www.csvw.com/u/cms/www/202512/23174640F961.jpg',
      list: [],
    },
  ],
};
